import { useFetchCreditsQuery } from "../services/api/creditsApi/credits";

import { useGetSelectedOrganisation } from "./useGetSelectedOrganisation";

export function useCredits() {
  const currentOrg = useGetSelectedOrganisation();
  const api = useFetchCreditsQuery({ organisationId: currentOrg?.id }, {
    skip: !currentOrg?.id,
    pollingInterval: 30 * 1000,
    skipPollingIfUnfocused: true,
  });

  api.data = api.data || {
    credits: [],
  };

  return api;
}
